export default () => {
  const userAuth = useCookie<BearerToken | null>('auth')
  const user = useState<User>('user')
  const {$customFetch} = useNuxtApp()

  const isAdmin = computed(() => {
    return user.value?.roles?.some(role => ['admin', 'super-admin'].includes(role.name)) || false
  })

  async function login(values: object) {
    const bearerToken = await $customFetch<BearerToken>('/api/login', {
      method: 'post',
      body: values,
    });

    if (bearerToken) {
      setTokens(bearerToken)
    }
  }

  function setTokens(tokens: BearerToken) {
    userAuth.value = tokens;
  }

  async function getMe() {
    const {data} = await $customFetch<ApiResponse<User>>('/api/me', {
      method: 'GET',
    });

    if (data) {
      user.value = data;

      if(data.must_change_password){
        return navigateTo({name: routeName.changePassword, query : { email : data.email }})
      }
    }

    return user;
  }


  return {
    login,
    getMe,
    user,
    isAdmin
  }
}
